// extracted by mini-css-extract-plugin
module.exports = {"container":"_1eQzs","mobile":"_1oA9h"};